<template>
  <div class="login">
      <aside class="login_top">
        <el-image
          style="width: 100px; height: 88px"
          src="https://static.zc0901.com/dci-miniapp/login-icon.png"
          class="mt4"        
        ></el-image>
      </aside>      
      <div class="login_tab">
        <el-tabs v-model="activeName" :stretch="true" @tab-click="changeTab">
          <el-tab-pane name="sms" class="quickLogin">
            <div slot="label" class="h2">快捷登录</div>
            <loginBySms ref="smsForm" />
          </el-tab-pane>
          <el-tab-pane name="psw">
            <div slot="label" class="h2">密码登录</div>
            <loginByPsw ref="pswForm" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
</template>
<script>
import loginByPsw from "./loginByPsw";
import loginBySms from "./loginBySms";
import './index.scss'
export default {
  components: { loginByPsw, loginBySms },
  data() {
    return {
      activeName: "sms",
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    changeTab() {
      if (this.activeName === "psw") this.$refs.pswForm.clearValidate();
      else this.$refs.smsForm.clearValidate();
    }
  }
};
</script>
<style scoped lang="scss">

</style>
<style lang="scss">

</style>
